import { createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom"
import { createRoutes, pageRoutes } from "./routes/page-routes"

const router = createBrowserRouter(createRoutesFromElements(createRoutes(pageRoutes)), {
  basename: "/"
})

const App = () => {
  return <RouterProvider router={router} />
}

export default App
